import { SHA256 } from "crypto-js";
import Hex from "crypto-js/enc-hex";
import StateDataService from "../../services/state-data-service/StateDataService";
import UserSettingsDataService from "../../services/user-settings-data/UserSettingsDataService";
//import { IUIUserFavorite, IUIUserFavoriteRouteDetail } from "../../common/models/IUIUserFavorite";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import UIPersonalizationDataService from "../../services/ui-personalization-data-service/UIPersonalizationDataService";
import { UserState } from "../../contexts/user-context/UserContext";
import UserDataService from "../../services/user-data-service/UserDataService";
import { IKeyValuePair } from "../../common/models/KeyValuePair";
import Enumerable from "linq";
import { CustomerTypeEnum } from "../../common/enums/CustomerTypeEnum";
import { IAuthenticationResult } from "../../common/models/AuthenticationResult";
import { ILoginCustomer } from "../../common/models/LoginCustomer";
import eLynxAuthService from "../../services/authentication/elynx-auth-service/ELynxAuthService";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import restService from "../../services/rest-service/RestService";
import storageService from "../../services/storage/storage-service/StorageService";
import { StorageKeys } from "../../services/storage/StorageKeys";
import { MfaSourceTypeEnum } from "../../common/enums/MfaSourceTypeEnum";
import msalAuthService from "../../services/authentication/msal-auth-service/MsalAuthService";
import { IeLynxUser } from "../../common/models/eLynxUser";
import { queryClient } from "../../services/query-client-service/QueryClientService";
import { IUIUserFavoriteModel, IUIUserFavoriteRouteDetailModel } from "../../services/ui-personalization-data-service/Models";
import CustomerDataService from "../../services/customer-data-service/CustomerDataService";

const LoginChangeCustomerStorageKey = "elynx.changecustomer";
const RedirectFromLogoutStorageKey = "elynx.redirectfromlogout";

export {LoginChangeCustomerStorageKey, RedirectFromLogoutStorageKey};


export type LoginAuthResult = {
    authenticationResult: IAuthenticationResult;
    userState: UserState;
};

export type LoginLocationStateFrom = {
    hash?: string;
    pathname?: string;
    search?: string;
}

export type LoginLocationState = {
    from: string | LoginLocationStateFrom
};

function getNextMfaTokenCookieName() {
    let name = "_frr";
    let count = 0;
    const tokens = LoginViewUtils.getMfaTokens();
    tokens.every(token => {
        if (token.Key === name) {
            name = `_frr${++count}`;
            return true;
        } else {
            return false;
        }
    });
    return name;
}

function setMfaTokenCookie(token: string, expiry: string) {
    if (token && expiry) {
        const tokenName = getNextMfaTokenCookieName();
        const gmtDate = new Date(Date.parse(expiry)).toUTCString();
        document.cookie = `${tokenName}=${encodeURIComponent(token)}; expires=${gmtDate}; path=/; SameSite=Strict; Secure`;
    }
}

async function _processAuthenticationResponse(customers: ILoginCustomer[],
    userState: UserState,
    authenticationResult: IAuthenticationResult) : Promise<UserState> {

    const customerList = customers?.length ? customers : authenticationResult.customers;
    const customer = customerList?.find(o => o.customerID === +authenticationResult.customerID);

    const autoRefreshPromise = StateDataService.getAutoRefreshIntervals();
    const userSettingsPromise = UserSettingsDataService.getUserSettings();

    const [refreshIntervals, userSettings] = await Promise.all([autoRefreshPromise, userSettingsPromise]);

    const user = authenticationResult.user ?? eLynxAuthService.getUser();

    if (user) {

        //console.log(`user stuff ${JSON.stringify(user)}`)
        user.contactEmail = user?.loginName;
        const name = user.displayText?.split(' ');
        if (name) {
            user.firstName = name.length ? name[0] : '';
            user.lastName = name.length > 1 ? name[1] : '';
        }

        if (authenticationResult.mfaToken && authenticationResult.mfaExpiry) {
            setMfaTokenCookie(authenticationResult.mfaToken, authenticationResult.mfaExpiry);
        }
    }

    const newUserState: UserState = {
        ...userState,
        authenticated: true,
        customer: {
            id: +authenticationResult.customerID,
            objectType: eLynxObjectTypeEnum.Customer,
            displayText: customer?.customerName || 'eLynx',
            customerType: +authenticationResult.customerTypeID as CustomerTypeEnum
        },
        user: user,
        startGroupID: user?.startGroup?.id,
        contextOrganizationID: user?.baseGroup?.organizationID,
        language: userSettings.language,
        unitSetID: userSettings.unitSetID,
        refreshIntervals: refreshIntervals,
        userSettings: userSettings,
        // mfaSource: userSettings.mfaSource,
        // mfaSecret: userSettings.mfaSecret,
        // mfaAccount: userSettings.mfaAccount
    };

    restService.setHeaderParams({
        unitSetID: `${userSettings.unitSetID}`,
        language: `${userSettings.language}`,
        timezone: userState.timezone,
        impersonatingUserID: undefined,
        impersonatingUserLogin: undefined
    });

    // set these session variables in case auto login for sso
    storageService.session.set(StorageKeys.LastUserName, authenticationResult.user?.loginName);
    storageService.session.set(StorageKeys.LastCustomerID, authenticationResult.customerID);
    storageService.session.set(StorageKeys.LastCustomerName, customer?.customerName ?? userState.customer?.displayText);

    storageService.local.set(StorageKeys.LastUserName, authenticationResult.user?.loginName);
    //storageService.session.set(StorageKeys.LastCustomerID, authenticationResult.customerID);
    //storageService.session.set(StorageKeys.LastCustomerName, customer?.customerName ?? userState.customer?.displayText);



    return newUserState;
};

// function _parseUserFavoriteFromHomeUrl(homeUrl: string): IUIUserFavorite | undefined {

//     let userFavorite: IUIUserFavorite | undefined;

//     // The favorite is returned as a string so needs to be pulled apart manually due to
//     // the names of fields having different casings depending on which JSON serializer
//     // is utilized
//     const tmpF = JSON.parse(homeUrl.trim());

//     if ((tmpF !== undefined) && (tmpF !== null)) {

//         userFavorite = <IUIUserFavorite>{};

//         if ((tmpF.Description !== undefined) && (tmpF.Description !== null)) {
//             userFavorite.description = tmpF.Description;
//         }

//         if ((tmpF.ID !== undefined) && (tmpF.ID !== null)) {
//             userFavorite.id = Number(tmpF.ID);
//         }

//         if ((tmpF.UserID !== undefined) && (tmpF.UserID !== null)) {
//             userFavorite.userID = Number(tmpF.UserID);
//         }

//         const tmpRd = tmpF.RouteDetail;

//         if ((tmpRd !== undefined) && (tmpRd !== null)) {

//             userFavorite.routeDetail = <IUIUserFavoriteRouteDetail>{};

//             if ((tmpRd.ConfigurationID !== undefined) && (tmpRd.ConfigurationID !== null)) {
//                 userFavorite.routeDetail.configurationID = Number(tmpRd.ConfigurationID);
//             }

//             if ((tmpRd.DeviceID !== undefined) && (tmpRd.DeviceID !== null)) {
//                 userFavorite.routeDetail.deviceID = Number(tmpRd.DeviceID);
//             }

//             if ((tmpRd.GroupID !== undefined) && (tmpRd.GroupID !== null)) {
//                 userFavorite.routeDetail.groupID = Number(tmpRd.GroupID);
//             }

//             if ((tmpRd.ObjectID !== undefined) && (tmpRd.ObjectID !== null)) {
//                 userFavorite.routeDetail.objectID = Number(tmpRd.ObjectID);
//             }

//             if ((tmpRd.ObjectType !== undefined) && (tmpRd.ObjectType !== null)) {
//                 userFavorite.routeDetail.objectType = <eLynxObjectTypeEnum>Number(tmpRd.ObjectType);
//             }

//             if ((tmpRd.OrganizationID !== undefined) && (tmpRd.OrganizationID !== null)) {
//                 userFavorite.routeDetail.organizationID = Number(tmpRd.OrganizationID);
//             }

//             if ((tmpRd.SearchCriteria !== undefined) && (tmpRd.SearchCriteria !== null) && (tmpRd.SearchCriteria.length > 0)) {
//                 userFavorite.routeDetail.searchCriteria = tmpRd.SearchCriteria.trim();
//             }

//             if ((tmpRd.SiteID !== undefined) && (tmpRd.SiteID !== null)) {
//                 userFavorite.routeDetail.siteID = Number(tmpRd.SiteID);
//             }

//             if ((tmpRd.TagID !== undefined) && (tmpRd.TagID !== null)) {
//                 userFavorite.routeDetail.tagID = Number(tmpRd.TagID);
//             }

//             if ((tmpRd.TankID !== undefined) && (tmpRd.TankID !== null)) {
//                 userFavorite.routeDetail.tankID = Number(tmpRd.TankID);
//             }

//             if ((tmpRd.UIView !== undefined) && (tmpRd.UIView !== null)) {
//                 userFavorite.routeDetail.uiView = <UIViewEnum>Number(tmpRd.UIView);
//             }

//             if ((tmpRd.WellID !== undefined) && (tmpRd.WellID !== null)) {
//                 userFavorite.routeDetail.wellID = Number(tmpRd.WellID);
//             }
//         };
//     }

//     return userFavorite;
// }

// async function validateUserFavorite(favorite: IUIUserFavorite): Promise<boolean> {

//     const result = await UIPersonalizationDataService.validateUserFavorite(favorite.id);

//     //??? is this necessary???
//     // try {
//     //     // Make sure the view has been implemented in the SCADALynx Azure application;
//     //     // required because some views/pages from the legacy SCADALynx application
//     //     // do not, currently, have corresponding views in the new application.
//     //     this._stateCatalogService.getStateByView(favorite.routeDetail.uiView);

//     // } catch (exception) {
//     //     validationResult.isValid = false;
//     //     validationResult.failureMessage = "The page for the favorite is not available."; // exception.message;

//     // }


//     return result.isValid;
// }

const LoginViewUtils = {

    authenticateFromAuthMsg: async function(userState: UserState,
        customerID: number,
        loginName: string
    ): Promise<LoginAuthResult | undefined> {

        // when we call the service to authenticate, login automatically is set to true
        // which tells the elynxAuthService to store important state in local storage.
        // It is necessary to set it here so the state can be read for this login attempt
        eLynxAuthService.setLoginAutomatically(true);

        const token = await eLynxAuthService.acquireToken();
        console.log(`token: ${token}`)

        const authMessage = eLynxAuthService.getAuthMessageFromStorage(loginName, customerID);

        const customers = await CustomerDataService.getCustomerList();
        const customer = customers.find(o => o.customerID === customerID);

        // an authentication message is available and we can find a customer with the customerID 
        // we are trying to use in the login process
        if (authMessage && customer) {

            const authResult: IAuthenticationResult = {
                customerID: authMessage.customerID,
                customerTypeID: authMessage.customerTypeID,
                user: eLynxAuthService.getUser(),
                customers: customers,
                mfaToken: authMessage.mfaToken,
                mfaExpiry: authMessage.mfaExpiry
            };

            // make a copy of the current user state
            const newUserState: UserState  = await _processAuthenticationResponse(customers, userState, authResult);

            queryClient.removeQueries();

            return {
                authenticationResult: authResult,
                userState: newUserState
            };        

        }

    },


    authenticate: async function(signIn: boolean,
        useIDToken: boolean,
        customers: ILoginCustomer[],
        userState: UserState,
        customerID: number | undefined,
        sso: boolean = false,
        userName: string | undefined = undefined,
        password: string | undefined = undefined,
        otp: string | undefined = undefined,
        mfaSource: MfaSourceTypeEnum | undefined = MfaSourceTypeEnum.Unconfigured,
        mfaToken: string | undefined = undefined,
        idToken?: string | undefined,
        passwordHashed?: boolean, // password is already hashed
        impersonatingGlobalLoginID?: number | undefined
    ): Promise<LoginAuthResult> {

        let result: IAuthenticationResult;

        if (useIDToken) {

            if (!idToken) {
                idToken = await UserDataService.getUserIDToken();
            }
            
            result = await eLynxAuthService.authenticateIDToken(customerID as number,
                idToken,
                window.outerHeight,
                window.outerWidth,
                false );

        } else if (!sso) {

            const hash: string = passwordHashed
                ? password as string
                : SHA256(password as string).toString(Hex);
            const mfaTokens = Enumerable.from(LoginViewUtils.getMfaTokens())
                .select(token => token.Value)
                .toArray();

            result = await eLynxAuthService.authenticate(customerID as number,
                             userName as string,
                             hash,
                             window.outerHeight,
                             window.outerWidth,
                             false,
                             true,
                             otp,
                             mfaSource,
                             mfaTokens.join(";"),
                             impersonatingGlobalLoginID);
        } else {

            if (signIn) {
                // when running in browser, sign in will redirect away from the application.
                // login redirect redirects away from the app whereas login popup method returns a promise here.
                await msalAuthService.signIn();
            }

            //console.log(`sso ${userState.user?.isElynxAdmin} and ${customers?.length}`);

            const token = await msalAuthService.getIDToken();
            result = await eLynxAuthService.authenticateSSO(customerID as number,
                        token as string,
                        window.outerHeight,
                        window.outerWidth,
                        false,
                        true,
                        /*userState.user?.isElynxAdmin*/
                        customers.length > 0);
        }

        // make a copy of the current user state
        let newUserState: UserState = {
            ...userState
        };

        if (customerID) {
            newUserState = await _processAuthenticationResponse(customers, userState, result);

            queryClient.removeQueries();

        }

        return {
            authenticationResult: result,
            userState: newUserState
        };
    },
    getDefaultURL: function (locationState: LoginLocationState, user: IeLynxUser, url?: string | undefined): string {

        let from: string | undefined = undefined;
        if (locationState?.from) {
            if (typeof(locationState.from) === 'string') {
                from = locationState.from;
            } else {

                const pathname = (locationState.from as LoginLocationStateFrom).pathname;
                const search = (locationState.from as LoginLocationStateFrom).search;

                if (pathname && search) {
                    from = `${pathname}${search}`;
                }
            }
        }

        from = from === '/' || !((from ?? '').indexOf('groupID=') === -1) ? undefined : from;
        return from ?? url ?? `/default/summary-listing?groupID=${user.startGroup?.id}`;
    },
    //@@todo use favorite (homeUrl) and include validation refer to scadalynx code
    //@@kg todo need place to provide url with params ??? maybe routes??? or a utility function

    parseUserFavoriteFromHomeUrl: function(homeUrl: string): IUIUserFavoriteModel | undefined {

        let userFavorite: IUIUserFavoriteModel | undefined;

        // The favorite is returned as a string so needs to be pulled apart manually due to
        // the names of fields having different casings depending on which JSON serializer
        // is utilized
        const tmpF = JSON.parse(homeUrl.trim());

        if ((tmpF !== undefined) && (tmpF !== null)) {

            userFavorite = {} as IUIUserFavoriteModel;

            if ((tmpF.Description !== undefined) && (tmpF.Description !== null)) {
                userFavorite.description = tmpF.Description;
            }

            if ((tmpF.ID !== undefined) && (tmpF.ID !== null)) {
                userFavorite.id = Number(tmpF.ID);
            }

            if ((tmpF.UserID !== undefined) && (tmpF.UserID !== null)) {
                userFavorite.userID = +tmpF.UserID;
            }

            const tmpRd = tmpF.RouteDetail;

            if ((tmpRd !== undefined) && (tmpRd !== null)) {

                userFavorite.routeDetail = {} as IUIUserFavoriteRouteDetailModel;

                if ((tmpRd.ConfigurationID !== undefined) && (tmpRd.ConfigurationID !== null)) {
                    userFavorite.routeDetail.configurationID = +tmpRd.ConfigurationID;
                }

                if ((tmpRd.DeviceID !== undefined) && (tmpRd.DeviceID !== null)) {
                    userFavorite.routeDetail.deviceID = +tmpRd.DeviceID;
                }

                if ((tmpRd.GroupID !== undefined) && (tmpRd.GroupID !== null)) {
                    userFavorite.routeDetail.groupID = +tmpRd.GroupID;
                }

                if ((tmpRd.ObjectID !== undefined) && (tmpRd.ObjectID !== null)) {
                    userFavorite.routeDetail.objectID = +tmpRd.ObjectID;
                }

                if ((tmpRd.ObjectType !== undefined) && (tmpRd.ObjectType !== null)) {
                    userFavorite.routeDetail.objectType = +tmpRd.ObjectType as eLynxObjectTypeEnum;
                }

                if ((tmpRd.OrganizationID !== undefined) && (tmpRd.OrganizationID !== null)) {
                    userFavorite.routeDetail.organizationID = Number(tmpRd.OrganizationID);
                }

                if ((tmpRd.SearchCriteria !== undefined) && (tmpRd.SearchCriteria !== null) && (tmpRd.SearchCriteria.length > 0)) {
                    userFavorite.routeDetail.searchCriteria = tmpRd.SearchCriteria.trim();
                }

                if ((tmpRd.SiteID !== undefined) && (tmpRd.SiteID !== null)) {
                    userFavorite.routeDetail.siteID = +tmpRd.SiteID;
                }

                if ((tmpRd.TagID !== undefined) && (tmpRd.TagID !== null)) {
                    userFavorite.routeDetail.tagID = +tmpRd.TagID;
                }

                if ((tmpRd.TankID !== undefined) && (tmpRd.TankID !== null)) {
                    userFavorite.routeDetail.tankID = +tmpRd.TankID;
                }

                if ((tmpRd.UIView !== undefined) && (tmpRd.UIView !== null)) {
                    userFavorite.routeDetail.uiView = +tmpRd.UIView as UIViewEnum;
                }

                if ((tmpRd.WellID !== undefined) && (tmpRd.WellID !== null)) {
                    userFavorite.routeDetail.wellID = +tmpRd.WellID;
                }
            };
        }

        return userFavorite;
    },

    validateUserFavorite: async function (favorite: IUIUserFavoriteModel): Promise<boolean> {

        if (favorite.routeDetail?.uiView === UIViewEnum.None) {
            return false;
        }

        const result = await UIPersonalizationDataService.validateUserFavorite(favorite.id);
        

        //??? is this necessary???
        // try {
        //     // Make sure the view has been implemented in the SCADALynx Azure application;
        //     // required because some views/pages from the legacy SCADALynx application
        //     // do not, currently, have corresponding views in the new application.
        //     this._stateCatalogService.getStateByView(favorite.routeDetail.uiView);

        // } catch (exception) {
        //     validationResult.isValid = false;
        //     validationResult.failureMessage = "The page for the favorite is not available."; // exception.message;

        // }

        return result.isValid;
    },

    getMfaTokens(): Array<IKeyValuePair<string, string>> {
        let list: Array<IKeyValuePair<string, string>> = new Array<IKeyValuePair<string, string>>();

        const tokens = document.cookie.split(";");
        tokens.forEach(token => {
            const trimmed = token.trim();
            if (trimmed.startsWith("_frr")) {
                const idx = trimmed.indexOf("=");
                list.push({
                    Key: trimmed.substr(0, idx),
                    Value: trimmed.substr(idx + 1)
                });
            }
        })

        return list;
    }

};

export default LoginViewUtils;